export default __webpack_public_path__ + "65e138c969c150a9fd31b2747f059ac3.png";